class SeznamMap {
    nic;
    container;
    drawButton;
    cancelButton;

    drawing = false;
    geometryLayer;
    markerLayer;
    markerCoords = [];
    drawnPolylines = [];
    map;
    mouseControl;
    onMapChangeCallback;
    mapChangeTimeout;
    mapChangeEvent;
    markerCluster;
    markerImg;

    constructor(container, drawButton, cancelButton) {
        this.container = container;
        this.drawButton = drawButton;
        this.cancelButton = cancelButton;

        this.map = L.map(container);

        L.tileLayer(window.SEZNAM_MAP_API_TILES_URL + window.SEZNAM_MAP_API_KEY,
        {
            minZoom: 0,
            maxZoom: 19,
            attribution: '<a href="https://api.mapy.cz/copyright" target="_blank">&copy; Seznam.cz a.s. a další</a>',
        }).addTo(this.map);

        this.geometryLayer = L.layerGroup().addTo(this.map);
        this.markerCluster = L.markerClusterGroup();

        this.markerCluster.on('clusterclick', (a) => {
            const mapZoom = this.map.getZoom();
            const maxZoom = 18;

            if (mapZoom >= maxZoom) {
                let infos = '';
                a.layer.getAllChildMarkers().forEach(marker => {
                    infos += marker.getPopup().getContent() + '<br>';
                });

                L.popup()
                    .setLatLng(a.latlng)
                    .setContent(infos)
                    .openOn(this.map);
            }
        });

        this.map.on('mousedown', (e) => this.map.dragging.enable());
        this.map.on('wheel', (e) => this.map.zoomControl.enable());

        this.map.on('draw:created', function (e) {
            var layer = e.layer;
            map.addLayer(layer);
        });

        this.map.dragging.enable();
        this.map.scrollWheelZoom.enable();
        this.map.doubleClickZoom.enable();
        this.map.touchZoom.enable();

        // Inicializace ovládacího prvku myši
        this.mouseControl = L.control.mousePosition ? new L.Control.MousePosition() : null;
        if (this.mouseControl) {
            this.mouseControl.addTo(map);
        }

    }

    async addLogo(logo) {
        addMapyLogo(L, this.map, logo);
    }

    async addMarkerImg(img) {
        this.markerImg =  L.icon({
            iconUrl: img,
        });
    }

    async geocodeItemToCoords(item) {
        return new Promise((resolve, reject) => {

            fetch('https://api.mapy.cz/v1/geocode/?apikey=' + window.SEZNAM_MAP_API_KEY + '&query=' + item.adresa)
                .then(response => response.json())
                .then(data => {

                    if (data.items[0]) {
                        const coords = data.items[0].location;
                        resolve(coords);
                    }
                    resolve(undefined);
                  });

        });
    }

    resetMap() {
        //this.markerLayer.clearLayers();
        this.geometryLayer.clearLayers();
        this.drawnPolylines = [];
    }

    async initialRender(items, type) {
        this.resetMap();
        const polygonBound = [];
        for (let i = 0; i < items.length; i++) {
            const item = items[i];
            if (item.loc_l && item.loc_w) {
                const coords = [item.loc_l, item.loc_w];
                coords.hash = item.hash;
                coords.card = item.card;
                coords.url = item.url;
                polygonBound.push(coords);
                this.markerCoords.push(coords);
            } else if (item.loc_l !== 0 && item.loc_w !== 0) { // pokud nemame souradnice, ale uz jsme se jednou pokusili ziskat
                const coords = await this.geocodeItemToCoords(item);
                if (coords && typeof coords === 'object') {
                    coords.hash = item.hash;
                    coords.card = item.card;
                    coords.url = item.url;
                    polygonBound.push(coords);
                    this.markerCoords.push(coords);
                    this.saveLocation(item, coords.lat, coords.lon);
                } else { //  ulozime, at se to priste nemusi nacitat pres geocode, nesmime je ale zobrazit v mape.
                    this.saveLocation(item, 0, 0);
                }
            }
        }

        if (typeof type !== 'undefined') {

            const polygon = L.polygon(polygonBound).addTo(this.geometryLayer);
            const bounds = polygon.getBounds();
            const center = bounds.getCenter();
            const zoom = this.map.getBoundsZoom(bounds);
            this.map.setView(centerZoom[1], centerZoom[0]);
        } else {
            this.renderMarkers(this.markerCoords);
        }

        this.map.on('click', (event) => {
            const marker = event.target;
            const cards = document.querySelectorAll(".js-map-card");
            var foundMarker = this.markerCoords.find((coord) => coord.hash === marker._leaflet_id);
            if  (foundMarker) {
                cards.forEach((card) => {
                    card.addEventListener("click", () => {
                        this.onMapChangeCallback([foundMarker], true);
                    });
                });
            }
        });

        // @TODO toto aktuale nedelame, jen smer mapa -> VUE ale ne Vue -> mapa
        // Z API dostanu data zlepsene nez ve var loc do VUE a aslaedne tam zavolam dispatch event, ktery bude dispathovat event, ktery bude tady.
        // Ve vue udelat funkci, ktera bude trabsformovat ten JSOn s nemovitostma na JS object (vlastni f/ci)
        this.onMapChangeCallback(this.markerCoords);
    }

    toggleDrawing(drawing) {
        this.drawing = drawing;
        if (drawing) {
            this.map.dragging.disable();
            if (this.mouseControl) {
                this.map.removeControl(this.mouseControl);
            }

            this.container.style.cursor = "crosshair";
            this.drawButton.style.display = "none";
            this.cancelButton.style.display = "inline-flex";
        } else {
            this.map.dragging.enable();
            if (this.mouseControl) {
                this.map.addControl(this.mouseControl);
            }

            this.container.style.cursor = "default";

            if (!this.drawnPolylines.length) {
                this.drawButton.style.display = "inline-flex";
                this.cancelButton.style.display = "none";
            }
        }
    }

    renderMarkers(markers) {
        this.markerCluster.clearLayers();
        const markersToRender = [];
        markers.forEach((coord) => {
            const marker = L.marker([coord[1], coord[0]], { icon:  this.markerImg });
            marker._leaflet_id = coord['hash'];
            if (coord['card']) {
                const cardContainer = document.createElement('div');
                cardContainer.id = 'card' + coord['hash'];
                cardContainer.classList.add('leaflet-popup-content');
                cardContainer.innerHTML = coord['card'];
                const marker = L.marker([coord[1], coord[0]], { icon:  this.markerImg })
                    .bindPopup(cardContainer);
                this.markerCluster.addLayer(marker);
                markersToRender.push([coord[1], coord[0]]);
            }
        });
        this.map.addLayer(this.markerCluster);
        const bounds = L.latLngBounds(markersToRender);
        this.map.fitBounds(bounds);
    }

    resetPolylinesAndRender = () => {
        this.resetMap();
        const visibleMarkers = this.getVisibleMarkers();
        this.onMapChangeCallback(visibleMarkers, false, true);
        this.renderMarkers(this.markerCoords);
        this.toggleDrawing(false);
    }

    setEventListeners() {

        document.querySelector('.JS-resize-map-big').addEventListener('click', () => {
            setTimeout(() => {
                if (this.map) {
                    this.map.invalidateSize();
                }
            }, 200);
        });

        this.drawButton?.addEventListener("click", () => {
            this.toggleDrawing(true);
        });

        this.cancelButton?.addEventListener("click", this.resetPolylinesAndRender);

        this.container?.addEventListener("mousedown", (event) => {
            if (this.drawing) {
                this.drawnPolylines = [];
                this.geometryLayer.clearLayers();
                this.map.on('mousemove', this.mousemoveListener);
            }
        });

        this.container?.addEventListener("mouseup", (event) => {
            if (this.drawing) {
                this.map.off('mousemove', this.mousemoveListener);
                this.geometryLayer.clearLayers();

                const polygon = L.polygon(this.drawnPolylines, {
                    color: "#f00",
                    weight: 2,
                    opacity: 0.1
                });

                const resPolygonWGS84 = [];

                polygon.getLatLngs().forEach((latLng) => {
                    const latLngWGS84 = [latLng.lat, latLng.lng];
                    resPolygonWGS84.push(latLngWGS84);
                });

                this.container.dispatchEvent(new CustomEvent("mapChangeEvent", {
                    detail: {
                        name: "PolygonDrawn",
                        polygonWGS84: resPolygonWGS84
                    },
                }));

                polygon.addTo(this.geometryLayer);

                const visibleMarkers = [];

                this.markerCoords.forEach((markerCoord) => {
                    const markerLatLng = L.latLng(markerCoord[1], markerCoord[0]);
                    if (polygon.getBounds().contains(markerLatLng)) {
                        visibleMarkers.push(markerCoord);
                    }
                });

                this.renderMarkers(visibleMarkers);
                this.toggleDrawing(false);
                this.onMapChangeCallback(visibleMarkers);
            }
        });

        this.map.on('move', this.mapChangeEventHandler);
        this.map.on('zoomend', this.mapChangeEventHandler);
        this.map.on('load', this.mapChangeEventHandler);
    }

    getWGS84Polygon = () => {
        // Získání hranic aktuálního pohledu mapy
        var bounds = this.map.getBounds();

        // Získání souřadnic rohů
        var lb = bounds.getSouthWest();
        var rt = bounds.getNorthEast();
        var lt = L.latLng(rt.lat, lb.lng);
        var rb = L.latLng(lb.lat, rt.lng);

        // Vytvoření polygonu
        var polygon = [
            [lb.lat, lb.lng], // Levý dolní roh
            [lt.lat, lt.lng], // Levý horní roh
            [rt.lat, rt.lng], // Pravý horní roh
            [rb.lat, rb.lng]  // Pravý dolní roh
        ];

        return polygon;
    }

    getVisibleMarkers = () => {
        const polygon = this.getWGS84Polygon();

        let markersToFilterFrom = this.markerCoords;
        if (this.drawnPolylines.length) {
            const polylineCoords = this.drawnPolylines.map(coord => [coord.x, coord.y]);
            markersToFilterFrom = this.markerCoords.filter(markerCoord =>
                this.pointInPolygon([markerCoord.x, markerCoord.y], polylineCoords)
            );
        }

        return markersToFilterFrom.filter(markerCoord =>
            this.pointInPolygon([markerCoord[1], markerCoord[0]], polygon)
        );
    };

    pointInPolygon = (point, vs) => {
        var x = point[0], y = point[1];

        var inside = false;
        for (var i = 0, j = vs.length - 1; i < vs.length; j = i++) {
            var xi = vs[i][0], yi = vs[i][1];
            var xj = vs[j][0], yj = vs[j][1];

            var intersect = ((yi > y) != (yj > y)) &&
                (x < (xj - xi) * (y - yi) / (yj - yi) + xi);
            if (intersect) inside = !inside;
        }

        return inside;
    }

    mapChangeEventHandler = () => {
        clearTimeout(this.mapChangeTimeout);

        this.mapChangeTimeout = setTimeout(() => {
            const visibleMarkers = this.getVisibleMarkers();
            this.onMapChangeCallback(visibleMarkers);
        }, 500);

        this.container.dispatchEvent(new CustomEvent("mapChangeEvent", {
            detail: {
                name: "MapChange",
                viewport: this.map.getBounds()
            },
        }));
    };

    mousemoveListener = (mouseEvent) => {
        const coords = mouseEvent.latlng;
        this.drawnPolylines.push([coords.lat, coords.lng]);
        this.geometryLayer.clearLayers();

        const polygon = L.polygon(this.drawnPolylines, {
            color: '#f00',
            weight: 2,
            opacity: 1
        });

        polygon.addTo(this.geometryLayer);

    };

    onMapChange(callback) {
        this.onMapChangeCallback = callback;
    }
}
  